import React, { useState, useEffect, useContext } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useSearch(spid, setSpid) {
    const { apiPrefix, uuidColumn } = useContext(ProductContext)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [purchasable, setPurchasable] = useState(false);

    useEffect(() => {
        getData()
    }, [spid])

    const getData = () => {
        if (!spid) return
        setLoading(true);
        setData({})
        setPurchasable(false);
        request(true).get(endpoints[`${apiPrefix}_GET_CUSTOMER`], {
            doesCancel: true,
            params: {
                search: spid
            }
        }).then(r => {
            if (!r.data.customer) window.alert('Could not find SPID.');
            setData(r.data.customer ?? {});
            setSpid(r.data.customer?.[uuidColumn] ?? '');
            setPurchasable(r.data.customer?.Date_Bought === null);
            setLoading(false);
        }).catch(e => {
            console.log(e)
            window.alert('An error occurred while fetching data.');
            setLoading(false);
        });
    }

    return { data, setData, getData, loading, purchasable, setPurchasable }
}